import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Kullanıcı deneyimleri" className="bg-transparent" data-id="element-262" data-mp="3ksgyi97eejdg">
      <div className="mx-auto max-w-6xl px-5 py-10" style={{
      paddingTop: "17px",
      paddingBottom: "19px"
    }} data-id="element-263" data-mp="3fy2zlwtj1u41">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-264" data-mp="3b01el6cjjkpx">
          🗣️ Sahadan gerçek deneyimler
        </h2>
        <div className="mt-8 grid w-full grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-265" data-mp="3205yqo81j1jk">
          {testimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.1} data-id="element-266" data-mp="2x004d0adz0xs" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}